/* @ngInject */
const trainCtrl = (
  $scope,
  $$train,
  $$wagon
) => {
  $scope.$$train = $$train
  $scope.$$wagon = $$wagon
}

export default trainCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/train/train.controller.js